import type { ExpExactEvidence } from '@/domain/types'
import { expRequirementRange, intersectExpRequirementRanges } from './exp-requirement-estimator'

export const EXP_TRANSITION_REVIEW_MS = 120_000

export function sameExpDigits(left: ExpExactEvidence, right: ExpExactEvidence): boolean {
  return left.value.absolute === right.value.absolute && left.value.ratio === right.value.ratio
    && (left.percentagePrecision ?? 2) === (right.percentagePrecision ?? 2)
}

export function compatibleExpRequirements(left: ExpExactEvidence['value'], right: ExpExactEvidence['value']): boolean {
  const before = expRequirementRange(left, left.percentagePrecision)
  const after = expRequirementRange(right, right.percentagePrecision)
  return before != null && after != null && intersectExpRequirementRanges([before, after]) !== undefined
}

export function freshLevel(level: { level: number; sourceAt: number } | null, expected: number, since: number): boolean {
  return level?.level === expected && level.sourceAt >= since
}

/** Zero has no requirement of its own; nonzero loss must still fit the old level. */
export function lossMatchesLevel(before: ExpExactEvidence['value'], after: ExpExactEvidence['value']): boolean {
  return after.absolute === 0 && after.ratio === 0 || compatibleExpRequirements(before, after)
}
